<template>
  <renew-list></renew-list>
</template>

<script>
import RenewList from '@/components/Renew/RenewList'

export default {
  name: 'RenewView',

  components: {
    RenewList,
  },
}
</script>
